import api from "@/configs/axios-config";

export type exchangeRate = {
  year: number;
  currency: Array<{
    id: number;
    currency_name: string;
  }>;
  suppliers: Array<{
    id: number;
    name_abbr: string;
  }>;
  base_prices: Array<{
    quarter: number;
    data: Array<{
      exchange_rate_price_id: number;
      year: number;
      quarter: number;
      supplier_id: number;
      currency_id: number;
      base_price: number;
    }>;
  }>;
};

export const getExchangeRatesByYear = async (
  year: number,
): Promise<exchangeRate> => {
  const response = await api.get(`/exchange-rates`, { params: { year } });
  return response.data;
};

export type updateExchangeRateBody = {
  prices: Array<{
    exchange_rate_price_id: number;
    base_price: number;
  }>;
  is_buyer_flagged: boolean;
};

export const updateExchangeRates = async (data: updateExchangeRateBody) => {
  const response = await api.put(`/exchange-rates`, data);
  return response.data;
};

export type createQuarterBody = {
  target_year: number;
  target_quarter: number;
};

export const createNewQuarterExchangeRates = async (
  params: createQuarterBody,
) => {
  const response = await api.post(`/exchange-rates/create-new-quarter`, params);
  return response.data;
};

export type currency = {
  id: number;
  currency_name: string;
  description: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
  created_by: string;
  updated_by: string;
};

export type currencyBody = {
  id?: number;
  currency_name: string;
  description: string;
  is_active?: boolean;
};

export const getCurrencies = async (): Promise<currency[]> => {
  const response = await api.get("/exchange-rates/currencies");
  return response.data;
};

export const createCurrency = async (data: currencyBody) => {
  const response = await api.post("/exchange-rates/currencies", {
    currency_name: data.currency_name,
    description: data.description,
  });
  return response.data;
};

export const updateCurrency = async (data: currencyBody) => {
  const response = await api.put(`/exchange-rates/currencies/${data.id}`, {
    currency_name: data.currency_name,
    description: data.description,
    is_active: data.is_active,
  });
  return response.data;
};

export type exchangeRateSupplier = {
  id?: string;
  name: string;
  name_abbr: string;
  is_active?: boolean;
  rounding?: "ROUND" | "ROUND UP" | "ROUND DOWN";
  rounding_digits?: number;
};

export const getExchangeRateSuppliers = async (): Promise<
  exchangeRateSupplier[]
> => {
  const response = await api.get("/exchange-rates/suppliers");
  return response.data;
};

export const createExchangeRateSupplier = async (
  data: exchangeRateSupplier,
) => {
  const response = await api.post("/exchange-rates/suppliers", {
    name: data.name,
    name_abbr: data.name_abbr,
    rounding: data.rounding,
    rounding_digits: data.rounding_digits,
  });
  return response.data;
};

export const updateExchangeRateSupplier = async (
  data: exchangeRateSupplier,
) => {
  const response = await api.put(`/exchange-rates/suppliers/${data.id}`, {
    name: data.name,
    name_abbr: data.name_abbr,
    is_active: data.is_active,
    rounding: data.rounding,
    rounding_digits: data.rounding_digits,
  });
  return response.data;
};
